import React from "react";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

export interface OptionCardProps {
  className?: string;
  style?: React.CSSProperties;
  label?: string;
  type?: "yes" | "no";
  description?: string;
  activeColor?: string;
  selected?: boolean;
  onSelect: (selected: boolean) => void;
}

const DEFAULT_ACTIVE_COLOR = "#51c1b2";
const GRAY = "#d9d9d9";
const DARK_GRAY = "#bfbfbf";

const OptionCard = ({
  className,
  style,
  label,
  type,
  description,
  activeColor = DEFAULT_ACTIVE_COLOR,
  selected,
  onSelect,
}: OptionCardProps) => {
  const borderColor = selected ? activeColor : GRAY;
  const iconColor = selected ? activeColor : DARK_GRAY;
  const icon =
    type === "no" ? (
      <CloseCircleTwoTone twoToneColor={iconColor} />
    ) : (
      <CheckCircleTwoTone twoToneColor={iconColor} />
    );

  return (
    <div
      className={className}
      style={style}
      onClick={() => onSelect(!selected)}
    >
      <div
        className={`flex flex-column pointer ba pv-1 ph-2 subtleLift`}
        style={{ borderColor: borderColor }}
      >
        {/* Option Label and Icon */}
        <div className="flex justify-between items-center">
          <div className="fwb">{label}</div>
          <div className="f-5">{icon}</div>
        </div>
        {/* Description */}
        <div>
          {description && (
            <p
              className="f-3 gray-8 lh-1"
              dangerouslySetInnerHTML={{ __html: description }}
              style={{ color: DARK_GRAY }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default OptionCard;
